import { AxiosPromise } from 'axios';
import axios from 'axios';
import { IGetNotification, IGetNotificationList, IGetNotifications, IGetSubjects, INotificationListParams, ISubjectParams, ISubjectParams2 } from '../models/notification.model';
import QueryString from 'qs';

const uri = '/mgmt/notification';

export const getNotifications = (classCode: string): AxiosPromise<IGetNotifications> => {
  return axios.get(`${uri}/${classCode}/calendar`);
};

export const getNotification = (notificationCode: number): AxiosPromise<IGetNotification> => {
  return axios.get(`${uri}/${notificationCode}`);
};

export const createNotification = (data: FormData): AxiosPromise => {
  return axios.post(uri, data);
};

export const updateNotification = (notificationCode: number, data: FormData): AxiosPromise => {
  return axios.put(`${uri}/${notificationCode}`, data);
};

export const deleteNotification = (notificationCode: number): AxiosPromise => {
  return axios.delete(`${uri}/${notificationCode}`);
};

export const getSubjects = (params: ISubjectParams): AxiosPromise<IGetSubjects> => {
  const qsParams = QueryString.stringify(params);
  return axios.get(`${uri}/subject?${qsParams}`);
};

export const getSubjects2 = (params: ISubjectParams2): AxiosPromise<IGetSubjects> => {
  const qsParams = QueryString.stringify(params);
  return axios.get(`${uri}/subject2?${qsParams}`);
};

export const getNotificationList = (params: INotificationListParams): AxiosPromise<IGetNotificationList> => {
  return axios.get(uri, { params });
};
